import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import React, { useState } from "react";
import pdfWorker from "react-pdf/src/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

const isImage = (mimeType) => mimeType.startsWith("image") && !mimeType.endsWith("tiff");
const isPDF = (mimeType) => mimeType === "application/pdf";

const PDFView = ({ data }) => {
  const [numPages, setNumPages] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState("Loading PDF…");

  function onPassword() {
    setLoadingMessage(
      "This pdf file has password protected, can't be viewed from browser. Please download it to check the content"
    );
  }

  const onDocumentLoaded = ({ numPages }) => {
    setNumPages(numPages);
  };

  const buildPages = () => {
    const pages = Array.from(Array(numPages), (_, i) => i + 1);
    return pages.map((pageNumber) => <Page pageNumber={pageNumber} key={pageNumber} />);
  };

  return (
    <Document
      file={`data:application/pdf;base64,${data}`}
      onLoadSuccess={onDocumentLoaded}
      onPassword={onPassword}
      loading={loadingMessage}
    >
      {buildPages()}
    </Document>
  );
};

const FileViewer = ({ data, mimeType }) => {
  if (mimeType && !isPDF(mimeType) && !isImage(mimeType)) {
    return <div>This file {mimeType} can't be viewed from browser. Please download it to check the content.</div>;
  }

  return (
    <>
      {(!mimeType || isPDF(mimeType)) && <PDFView data={data} />}
      {mimeType && isImage(mimeType) && <img src={`data:image/jpeg;base64,${data}`} alt="File" />}
    </>
  );
};

export default FileViewer;
